(function() {
  'use strict';
  /*
   * resolved by router: overview, paymentInfo
   */
  angular
    .module('eclipseApp.myAccount')

    .controller('overviewCtrl', [
      '$scope',
      '$state',
      '$rootScope',
      '$http',
      '$cookies',
      '$filter',
      '$sessionStorage',
      'uteEndpoint',
      'uteModal',
      'uteLocale',
      '$stateParams',
      'getAccountDetails',
      'commonService',
      'changeTechInstallService',
      'httpService',
      'prepaidUserInfoService',
      'prepaidAirtimeBalanceService',
      'prepaidPlanInfoService',
      'prepaidAutoRefillInfoService',
      'notifier',
      'userPrefService',
      '$window',
      'permissionsService',
      'pricePlanInitiation',
      'dtmServiceConstants',
      'dtmService',
      '$timeout',
      '$translate',
      'brtSwitchCMS',
      'janrainService',
      'BFA_CONSTANTS',
      'onlineBillingService',
      'brt',
      'ngRouter',
      'ute.fido.bpo.integration.common.service',
      'ute.blocks.persistent.storage.service',
      function(
        $scope,
        $state,
        $rootScope,
        $http,
        $cookies,
        $filter,
        $sessionStorage,
        uteEndpoint,
        uteModal,
        uteLocale,
        $stateParams,
        getAccountDetails,
        commonService,
        changeTechInstallService,
        httpService,
        prepaidUserInfoService,
        prepaidAirtimeBalanceService,
        prepaidPlanInfoService,
        prepaidAutoRefillInfoService,
        notifier,
        userPrefService,
        $window,
        permissionsService,
        pricePlanInitiation,
        dtmServiceConstants,
        dtmService,
        $timeout,
        $translate,
        brtSwitchCMS,
        janrainService,
        BFA_CONSTANTS,
        onlineBillingService,
        brt,
        ngRouter,
        bpoIntegrationService,
        uteBlocksPersistentStorageService
      ) {
        var dynatracePageLoadActionId = null;
        $scope.creditLimit = {
          creditLimitUsedPercentage: 0,
          totalCreditLimitAmount: 0,
          totalCreditLimit: '',
          totalUsedCreditLimit: '',
          totalRemainingCreditLimit: '',
          creditLimitWarningDesc: '',
          creditLimitWarningHeading: '',
          creditLimitRecommendedPaymentAmount: ''
        };

        $scope.searchType = function(ban, ctn, lob) {
          // $state.go('myAccount.wireless' , {'accountNumber': ban, 'subscriberNo': ctn});
          if (lob == 'WL') {
            $state.go('myAccount.wireless', { accountNumber: ban, subscriberNo: ctn });
          } else {
            $state.go('myAccount.prepaidWLDashboard', { accountNumber: ban, subscriberNo: ctn });
          }
        };

        $scope.accountStatus = function(accountNumber) {
          var currentAccount = _.find($rootScope.userInfo.accounts, function(account) {
            return account.accountNumber === accountNumber;
          });
          if (currentAccount && currentAccount.status) {
            return currentAccount.status.toUpperCase();
          } else {
            return '';
          }
        };

        $scope.showCallerId = brtSwitchCMS.brtSwitch.callerIdFlow;
        $scope.showOnlinePromo = false;
        $scope.showBillNotification = false;
        $scope.enableAALFlow = brtSwitchCMS.brtSwitch.enableAALFlow;
        $scope.accountsLength =
          $rootScope.userInfo && $rootScope.userInfo.accounts && $rootScope.userInfo.accounts.length;
        $scope.restoreDataAccess = function(accessLabel) {
          var janrainCaptureProfileData = JSON.parse(localStorage.getItem('easyLoginDataJanrain'));
          var WCOCCreateTokenData = JSON.parse(sessionStorage.getItem('WCOCCreateTokenData'));

          var loginType = $rootScope.userInfo.loginType || WCOCCreateTokenData.loginType || 'email';
          var userId = janrainCaptureProfileData.userID || WCOCCreateTokenData.userId;
          var uuid = $rootScope.userInfo.uuid || WCOCCreateTokenData.uuid;
          var profileType = janrainCaptureProfileData.profileType || WCOCCreateTokenData.profileType || '1';
          var msisdn = $rootScope.userInfo.msisdn || WCOCCreateTokenData.msisdn || 'null';
          var accountId = $rootScope.userInfo.account_id || WCOCCreateTokenData.accountId || null;

          $http
            .post(uteEndpoint('v1/wcoc/createjwttoken'), {
              language: uteLocale.language,
              applicationId: BFA_CONSTANTS.APPLICATION_ID,
              accountId: accountId,
              loginType: loginType,
              msisdn: msisdn,
              profileType: profileType,
              userId: userId,
              uuid: uuid
            })
            .success(function(data, status, headers, config) {
              $window.localStorage.setItem('wcocToken', data);
              if (accessLabel === 'manage') {
                var redirectionUri =
                  $window.location.origin || $window.location.protocol + '//' + $window.location.hostname;
                redirectionUri =
                  redirectionUri + '/web/wcoc/#/manage-users/' + uteLocale.language.toUpperCase() + '/F?entryId=D';
                $window.open(redirectionUri, '_self');
              } else if (accessLabel === 'reset') {
                var redirectionUri =
                  $window.location.origin || $window.location.protocol + '//' + $window.location.hostname;
                redirectionUri =
                  redirectionUri + '/web/wcoc/#/restore-data/' + uteLocale.language.toUpperCase() + '/F?entryId=D';
                $window.open(redirectionUri, '_self');
              }
            })
            .error(function(data, status, headers, config) {
              console.log(data);
            });
        };
        // $scope.loadFirstTimePopUp = function () {
        //   $http({
        //     method: 'POST',
        //     url: uteEndpoint('v1/user/preferences')
        //   }).success(function (data) {
        //     if (data.error) {
        //       if (userPrefService.getShowFirstTimeLoginPopUp()) {
        //         uteModal.open({
        //           controller: 'firstTimeLoginPopUpCtrl',
        //           templateUrl: 'modules/my-account/overview/first-time-login-popup.html',
        //           ok: function () {
        //             console.log('OK');
        //           },
        //           cancel: function () {
        //             userPrefService.setShowFirstTimeLoginPopUp(false);
        //             console.log('CANCEL');
        //           }
        //         });
        //       }
        //     }
        //   }).error(function (data) {
        //   });
        // };
        //first time login pop up only for customer
        /* if (!($rootScope.ruiMethods.user.is.agent())) {
         $scope.loadFirstTimePopUp();
         }
         FUSS-1395 : Remove 'Welcome to My Account' modal upon sign-in */

        $scope.userHasInternetTV = false;
        $scope.showServiceAddress = false;
        $scope.$storage = $sessionStorage;
        // $scope.getFidoDollar = function (fidoDollarList, cacheRefreshState) {
        //   var promise = httpService.send(
        //     'v1/wireless/rewards/basicinfo',
        //     {
        //       fidoDollarBalanceFormList: fidoDollarList,
        //       accountNumber: fidoDollarList[0].accountNumber,
        //       refresh: cacheRefreshState
        //     });
        //   promise.then(
        //     function (result) {
        //       if (result && result.data && result.data.error === null && result.data.fidoDollarBalanceInfoList) {
        //         _.each($scope.accountDetails, function (accountDetail) {
        //           _.each(result.data.fidoDollarBalanceInfoList, function (data) {
        //             if ((data.accountNumber === accountDetail.accountNumber) && (data.error === null)) {
        //               accountDetail.fidoDollarsEligibility = data.eligibility;
        //               accountDetail.fidoDollarNewBalance = data.fidoDollarBalance;
        //             }
        //           });
        //         });
        //       }
        //       if (result.data.cachedResultInfo == null || result.data.cachedResultInfo == "" || (result.data.cachedResultInfo && result.data.cachedResultInfo.expired)) {
        //         if (!cacheRefreshState) {
        //           $scope.getFidoDollar(fidoDollarList, true);
        //         }
        //       }
        //     },
        //     function (reason) {
        //       $scope.fidoDollarError = true;
        //     }
        //   );
        // }

        function setCreditLimitExceededWarning(creditLimitUsedPercentage) {
          if (creditLimitUsedPercentage >= 100) {
            $translate('global.label.creditLimitExceeded').then(function(translatedValue) {
              $scope.creditLimit.creditLimitWarningHeading = translatedValue;
            });
            $translate('global.label.creditLimitExceededMessage').then(function(translatedValue) {
              $scope.creditLimit.creditLimitWarningDesc = translatedValue;
            });
          } else if (creditLimitUsedPercentage >= 75 && creditLimitUsedPercentage < 100) {
            $translate('global.label.creditLimitAlmost').then(function(translatedValue) {
              $scope.creditLimit.creditLimitWarningHeading = translatedValue;
            });
            $translate('global.label.creditLimitPercentage70Message', { limitPercentage: 75 }).then(function(
              translatedValue
            ) {
              $scope.creditLimit.creditLimitWarningDesc = translatedValue;
            });
          } else if (creditLimitUsedPercentage >= 60 && creditLimitUsedPercentage < 75) {
            $translate('global.label.nearingCreditLimit').then(function(translatedValue) {
              $scope.creditLimit.creditLimitWarningHeading = translatedValue;
            });
            $translate('global.label.creditLimitPercentage60Message', { limitPercentage: 60 }).then(function(
              translatedValue
            ) {
              $scope.creditLimit.creditLimitWarningDesc = translatedValue;
            });
          }
        }

        function accountCreditLimitDetails(account) {
          $scope.creditLimit.totalCreditLimitAmount = account.creditLimit;
          if (account.creditLimit > 0) {
            var totalUsedCreditLimitAmount = 0;
            account.creditLimit = parseFloat(account.creditLimit).toFixed(2);
            account.availableCreditAmount = parseFloat(account.availableCreditAmount).toFixed(2);
            account.creditLimit = parseFloat(account.creditLimit).toFixed(2);

            totalUsedCreditLimitAmount = (account.creditLimit - account.availableCreditAmount).toString();
            totalUsedCreditLimitAmount = parseFloat(totalUsedCreditLimitAmount).toFixed(2);

            $scope.creditLimit.creditLimitUsedPercentage = account.creditLimitUsedPercentage;
            account.recommendedPaymentAmount =
              $scope.language === 'fr'
                ? account.recommendedPaymentAmount.toString().replace('.', ',')
                : account.recommendedPaymentAmount;
            setCreditLimitExceededWarning($scope.creditLimit.creditLimitUsedPercentage);

            $translate('global.label.creditLimit', {
              amount: $scope.language === 'fr' ? account.creditLimit.replace('.', ',') : account.creditLimit
            }).then(function(translatedValue) {
              $scope.creditLimit.totalCreditLimit = translatedValue;
            });
            $translate('global.label.creditLimitUsed', {
              amount:
                $scope.language === 'fr' ? totalUsedCreditLimitAmount.replace('.', ',') : totalUsedCreditLimitAmount
            }).then(function(translatedValue) {
              $scope.creditLimit.totalUsedCreditLimit = translatedValue;
            });
            $translate('global.label.creditLimitRemaining', {
              amount:
                $scope.language === 'fr'
                  ? account.availableCreditAmount.replace('.', ',')
                  : account.availableCreditAmount
            }).then(function(translatedValue) {
              $scope.creditLimit.totalRemainingCreditLimit = translatedValue;
            });
            $translate('global.label.creditLimitRecommendPaymentAmount', {
              amount: account.recommendedPaymentAmount
            }).then(function(translatedValue) {
              $scope.creditLimit.creditLimitRecommendedPaymentAmount = translatedValue;
            });
          }
        }

        $scope.accountPreference = function(flowName, sectionName, actionType) {
          if ($scope.accountsLength === 1) {
            var firstSubscriberNo = '';
            if (flowName === 'viewUsage') {
              if (
                $scope.accountDetails[0].accountStatus.toUpperCase() !== 'CANCELLED' &&
                $scope.accountDetails[0].accountStatus.toUpperCase() !== 'SUSPENDED'
              ) {
                if ($scope.accountDetails[0].hasWireless) {
                  flowName =
                    $scope.accountDetails[0].LOB && $scope.accountDetails[0].LOB === 'WLPP'
                      ? 'prepaidWLDashboard'
                      : 'wireless';
                  firstSubscriberNo = $scope.accountDetails[0].subscriberServices[0].wireless.subscriberNo;
                } else if (!$scope.accountDetails[0].hasWireless) {
                  flowName = 'internetUsage.daily';
                  firstSubscriberNo = $scope.accountDetails[0].subscriberServices[0].internet.subscriberNo;
                }
                var stateValue = 'myAccount.' + flowName;
                $state.go(stateValue, {
                  accountNumber: $rootScope.userInfo.accounts[0].accountNumber,
                  subscriberNo: firstSubscriberNo,
                  sectionName: sectionName
                });
              }
            } else {
              if (flowName === 'viewProfile') {
                ngRouter.navigateByUrl('/myaccount/view-profile#' + sectionName);
              } else {
                if (flowName === 'payNow') {
                  flowName =
                    $scope.accountDetails[0].LOB && $scope.accountDetails[0].LOB === 'WLPP'
                      ? 'prepaidRefill'
                      : 'payNow';
                } else if (flowName === 'viewInvoice') {
                  flowName =
                    $scope.accountDetails[0].LOB && $scope.accountDetails[0].LOB === 'WLPP'
                      ? 'viewTransactionHistory'
                      : 'viewInvoice';
                }
                var stateValue = 'myAccount.' + flowName;
                $state.go(stateValue, {
                  accountNumber: $rootScope.userInfo.accounts[0].accountNumber,
                  subscriberNo: firstSubscriberNo,
                  sectionName: sectionName,
                  action: actionType
                });
              }
            }
          } else {
            uteModal.open({
              templateUrl: 'modules/my-account/overview/accounts-modal.html',
              controller: 'accountDetailsModalCtrl',
              windowTemplateUrl: 'views/templates/modal/small-size-window.html',
              size: 'sm-custom',
              data: {
                flowName: flowName,
                sectionName: sectionName,
                action: actionType
              },
              ok: function() {
                console.log('OK');
              },
              cancel: function() {
                console.log('CANCEL');
              }
            });
          }
        };
        //          FUSS - 1621 START
        if ($stateParams && $stateParams.isUsageDeepLink === 'Y') {
          commonService.deepLinkState = 'view-usage';
        }
        $scope.deepLinking = function() {
          if (
            commonService.deepLinkState &&
            (commonService.deepLinkState.indexOf('pay-now') >= 0 ||
              commonService.deepLinkState.indexOf('view-invoice-history') >= 0 ||
              commonService.deepLinkState.indexOf('view-usage') >= 0)
          ) {
            console.log(commonService.deepLinkState);
            var nextState;
            if (commonService.deepLinkState.indexOf('pay-now') >= 0) {
              nextState = 'payNow';
            } else if (commonService.deepLinkState.indexOf('view-invoice-history') >= 0) {
              nextState = 'viewInvoice';
            } else if (commonService.deepLinkState.indexOf('view-usage') >= 0) {
              nextState = 'viewUsage';
            }
            commonService.deepLinkState = '';
            $scope.accountPreference(nextState, '');
          } else if (commonService.deepLinkState && commonService.deepLinkState.indexOf('social-media') >= 0) {
            commonService.deepLinkState = '';
            $state.go('socialMedia');
          } else if (commonService.deepLinkState && commonService.deepLinkState.indexOf('live-chat') >= 0) {
            var sourceCode = '';
            if (commonService.deepLinkState.indexOf('?source') >= 0) {
              sourceCode = commonService.deepLinkState.split('?source=')[1];
              console.log('live chat deeplink:' + commonService.deepLinkState + 'source:' + sourceCode);
            }
            commonService.deepLinkState = '';
            $state.go('myAccount.liveChat', { source: sourceCode });
          } else if (commonService.bfaDeepLinkURL && commonService.bfaDeepLinkURL.indexOf('add-a-line') >= 0) {
            $rootScope.payNowButton = 'enablePayNowButton';
            commonService.deepLinkState = '';
            commonService.checkAALEligibility();
          }
        };
        /*setTimeout(function () {
         $scope.deepLinking();
         }, 2000);*/
        // FUSS - 1621 END
        $scope.filterWirelessCFA = function(account) {
          return $rootScope.ruiMethods.user.is.agent() === false || account.serviceName !== 'Wireless';
        };
        $scope.filterTentativeAccount = function(account) {
          return account && account.status !== 'TENTATIVE';
        };

        $scope.getDefaultAccount = function() {
          var accountDefault = false;
          var i = 1;
          _.each($rootScope.userInfo.accounts, function(account) {
            if (
              i == 1 &&
              account &&
              account.accountNumber &&
              $scope.filterWirelessCFA(account) &&
              $scope.filterTentativeAccount(account)
            ) {
              accountDefault = account;
              i = i + 1;
            }
          });
          return accountDefault;
        };

        $scope.init = function() {
          try {
            dynatracePageLoadActionId = dtrum.enterAction('page load – Account OverView', 'change');
          } catch (error) {}
          /* we can initialize onlineBillingService at this point because we know for sure accountDetails is available
           * onlineBillingService.init need to be removed after refactoring commonService
           */
          onlineBillingService.init(commonService.accountDetails);
          $translate([
            'ute.add_to_calendar.event_title',
            'ute.add_to_calendar.location',
            'ute.add_to_calendar.button_label',
            'ute.add_to_calendar.description'
          ]).then(function(translation) {
            $scope.addToCalendar = {
              eventTitle: translation['ute.add_to_calendar.event_title'],
              location: translation['ute.add_to_calendar.location'],
              buttonLabel: translation['ute.add_to_calendar.button_label'],
              description: translation['ute.add_to_calendar.description']
            };
          });

          var internetTvAccountsCount = 0;
          $scope.isSubscriber = false;
          var fidoDollarList = [];
          $scope.globalMessage = $stateParams.globalMessage;
          $scope.accountDetails = commonService.accountDetails;
          $scope.accounts = $rootScope.userInfo.accounts;
          $scope.wirelessCount = commonService.wirelessCount;
          $scope.userProvince = uteLocale.province.toUpperCase();
          // var getFidoDollarDetails = false;
          $scope.prepaidOnly = false;
          $scope.wcocWirelessBan = false;

          if ($rootScope.userInfo) {
            //$rootScope.userInfo.selectedAccountNumber = '';
            console.log($rootScope.userInfo.selectedAccountNumber);
            $rootScope.userInfo.selectedSubscriberNo = '';
            if (
              $rootScope.userInfo.profileType &&
              $rootScope.userInfo.profileType.subscriber != null &&
              $rootScope.userInfo.profileType.subscriber != ''
            ) {
              $scope.isSubscriber = $rootScope.userInfo.profileType.subscriber;
            }
          }

          if ($stateParams.accountNumber) {
            $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
            $scope.accountNumberSelected = $stateParams.accountNumber;
            console.log('accountNumberSelected:state:', $scope.accountNumberSelected);
          } else if (!$stateParams.accountNumber && $rootScope.userInfo.selectedAccountNumber) {
            $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
            $scope.accountNumberSelected = $rootScope.userInfo.selectedAccountNumber;
            console.log('accountNumberSelected:rootscope:', $scope.accountNumberSelected);
          } else {
            if ($scope.getDefaultAccount().accountNumber) {
              $scope.accountNumber = $scope.getDefaultAccount();
              $scope.accountNumberSelected = $scope.getDefaultAccount().accountNumber;
            }
            console.log('accountNumberSelected:default:', $scope.accountNumberSelected);
          }
          if ($scope.accounts) {
            // Wcoc changes ::  START
            $.each($scope.accounts, function(value, index) {
              if (
                $scope.accountNumberSelected === index.accountNumber &&
                index.serviceName &&
                index.serviceName.toLowerCase() === 'wireless' &&
                index.status &&
                index.status.toUpperCase() !== 'CANCELLED'
              ) {
                $scope.wcocWirelessBan = true;
              }
            });
            // Wcoc changes :: END
            $.each($scope.accounts, function(value, index) {
              if (index.serviceName === 'Internet/TV') {
                $scope.userHasInternetTV = true;
                internetTvAccountsCount += 1;
              } else if (
                index.serviceName &&
                index.status &&
                index.serviceName.toLowerCase() === 'wireless' &&
                $scope.accountNumberSelected === index.accountNumber &&
                index.status.toLowerCase() === 'open'
              ) {
                $scope.userHasWireless = true;
                console.log('WIRELESS', index);
              }
              /*else{
                       if(uteLocale.province.toLowerCase() != 'on'){
                            $scope.userHasInternetTV = true ;
                          }
                       }
               FUSS-356 : commented out for adding check for billing province in html*/
            });
          }
          $scope.changeCallerId = function() {
            var subscriberCTN = '';
            var selectedAccountDetail;
            console.log('$scope.accountNumberSelected', $scope.accountNumberSelected);
            if ($scope.accountNumberSelected) {
              selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
                return accountDetail.accountNumber === $scope.accountNumberSelected;
              });
            }
            if (!_.isEmpty(selectedAccountDetail.subscriberServices)) {
              for (var i = 0; i < selectedAccountDetail.subscriberServices.length; i++) {
                if (
                  selectedAccountDetail.subscriberServices[i].wireless != null &&
                  selectedAccountDetail.subscriberServices[i].wireless.subscriberNo != null
                ) {
                  subscriberCTN = selectedAccountDetail.subscriberServices[i].wireless.subscriberNo;
                  break;
                }
              }
            }
            console.log('change caller ID:::', $scope.accountNumberSelected + '....' + subscriberCTN);
            uteModal.open({
              templateUrl: 'modules/my-account/wireless/change-caller-id.html',
              windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
              controller: 'changeCallerIdCtrl',
              windowClass: 'change-caller-id-specific',
              backdrop: 'static',
              size: 'lg',
              data: {
                ctnSelected: subscriberCTN,
                accountNumberSelected: $scope.accountNumberSelected
              },
              ok: function() {},
              cancel: function() {}
            });
          };
          //FUSS-3047 DTM changes for selected BAN
          var existingDTMVar = dtmService.getVar(dtmServiceConstants.dtmRules.selectedBAN.parameterName);
          if (
            typeof existingDTMVar === 'undefined' ||
            (typeof existingDTMVar !== 'undefined' && existingDTMVar != $scope.accountNumberSelected)
          ) {
            dtmService.setVar(dtmServiceConstants.dtmRules.selectedBAN.parameterName, $scope.accountNumberSelected);
            dtmService.direct(dtmServiceConstants.dtmRules.selectedBAN.ruleName);
          }
          if (internetTvAccountsCount > 1) {
            $scope.showServiceAddress = true;
          } else {
            $scope.showServiceAddress = false;
          }

          _.each($scope.accountDetails, function(accountDetail) {
            var fidoDollarObj = {};
            var prepaidCount = 0;
            if (accountDetail.accountNumber === $scope.accountNumberSelected) {
              //BPO integration
              if (
                !_.isEmpty(accountDetail.cachedResultInfo) &&
                accountDetail.cachedResultInfo && !accountDetail.cachedResultInfo.expired
              ) {
                if (
                  accountDetail.hasWireless &&
                  accountDetail.subscriberServices && accountDetail.subscriberServices.length > 0
                ) {
                  bpoIntegrationService.displayTargetedHeroOffers(
                    $scope.accountNumberSelected,
                    accountDetail.subscriberServices
                  );
                }
              }
              var overviewAmount = accountDetail.balance;

              accountCreditLimitDetails(accountDetail);

              if (accountDetail.hasWireless) {
                $scope.servicesListTitleKey =
                  accountDetail.subscriberServices.length > 1
                    ? 'global.label.view_usage_manage_wireless_multiple_ctn'
                    : 'global.label.view_usage_manage_wireless_one_ctn';
                $scope.showAddMoreServices =
                  accountDetail.LOB !== 'WLPP' &&
                  ((accountDetail.billingProvince && accountDetail.billingProvince === 'ON') ||
                    (!accountDetail.billingProvince && $scope.userProvince === 'ON'));
              } else if (accountDetail.hasInternet) {
                $scope.servicesListTitleKey = 'global.label.view_usage_manage_wireless_internet';
                $scope.showAddMoreServices = false;
              }

              if ($scope.language === 'fr') {
                overviewAmount = parseFloat(overviewAmount).toFixed(2);
                $scope.overviewBalance = overviewAmount.toString().replace('.', ',');
              } else {
                $scope.overviewBalance = parseFloat(overviewAmount).toFixed(2);
              }
              if (
                brtSwitchCMS.brtSwitch.showEmailNotification &&
                accountDetail.billingType && accountDetail.billingType.toLowerCase() === 'online' &&
                accountDetail.LOB && accountDetail.LOB.toUpperCase() !== 'WLPP' &&
                !_.isEmpty(accountDetail.contactEmail) &&
                $rootScope.userInfo.userID !== $window.localStorage.getItem('hideBillNotificationMessage')
              ) {
                $scope.showBillNotification = true;
                $scope.userContactEmail = accountDetail.contactEmail;
              }
              if (!_.isEmpty(accountDetail.accountType) && !_.isEmpty(accountDetail.accountSubType)) {
                $window.localStorage.setItem('selectedAccType', accountDetail.accountType);
                $window.localStorage.setItem('selectedAccSubType', accountDetail.accountSubType);
              }
              if (accountDetail.hasWireless && accountDetail.LOB === 'WLPP') {
                prepaidUserInfoService.setBAN(accountDetail.accountNumber);
                $scope.$storage.selectedBAN = accountDetail.accountNumber;
                $scope.userHasWireless = false;
                prepaidCount++;
                _.each(accountDetail.subscriberServices, function(subscriberService) {
                  if (subscriberService.wireless.serviceName === 'CTN') {
                    prepaidUserInfoService.setCTN(subscriberService.wireless.subscriberNo);
                    $scope.$storage.selectedCTN = subscriberService.wireless.subscriberNo;
                  }
                });
              } /*else if (accountDetail.hasWireless && accountDetail.LOB === 'WL'){
               // CQUSR01225927 Fix
               _.each(accountDetail.subscriberServices, function (subscriberService) {
               if (subscriberService.wireless.serviceName == 'CTN') {
               console.log("subscriberService.wireless.subscriberNo: ", subscriberService.wireless.subscriberNo);
               //pricePlanInitiation.initiate('ppc', subscriberService.wireless.subscriberNo);
               }
               });
               }*/ //Merge else if loop of CQUSR01225927 Fix and fido dollar
              else if (accountDetail.hasWireless && accountDetail.LOB && accountDetail.LOB.toLowerCase() === 'wl') {
                _.each(accountDetail.subscriberServices, function(subscriberService) {
                  if (
                    subscriberService &&
                    subscriberService.wireless &&
                    subscriberService.wireless.serviceName &&
                    subscriberService.wireless.serviceName.toLowerCase() === 'ctn'
                  ) {
                    fidoDollarObj.phoneNumber = subscriberService.wireless.subscriberNo;
                    fidoDollarObj.accountNumber = accountDetail.accountNumber;
                    // getFidoDollarDetails = true;
                    // console.log("subscriberService.wireless.subscriberNo: ", subscriberService.wireless.subscriberNo);
                    //pricePlanInitiation.initiate('ppc', subscriberService.wireless.subscriberNo);
                  }
                });
                fidoDollarList.push(fidoDollarObj);
              }

              if ($scope.accountsLength === prepaidCount) {
                $scope.prepaidOnly = true;
              }
            }
          });
          // if (getFidoDollarDetails)
          //   $scope.getFidoDollar(fidoDollarList, false);
        };

        $scope.filterSelectedAccount = function(account) {
          return account.accountNumber === $scope.accountNumberSelected;
        };

        $scope.language = uteLocale.language;
        $scope.fetchWLPPInfoOnDirectLoad = function() {
          $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
        };

        $scope.getPlanAndAddOnInfo = function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.planAndAddOnInfoError = true;
              } else {
                $scope.planAndAddOnInfo = result.data;
                console.log('$scope.planAndAddOnInfo :: ' + $scope.planAndAddOnInfo);
                prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
                prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
                prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
                $scope.pricePlanInfo = null;
                if (result.data.planDetailsInfo != null) {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                  } else {
                    $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                  }
                  if (result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != '') {
                    prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                  }
                  if (
                    $scope.pricePlanInfo != null &&
                    $scope.pricePlanInfo.planComparison != null &&
                    $scope.pricePlanInfo.planComparison.planTitle != null &&
                    $scope.pricePlanInfo.planComparison.planTitle != ''
                  ) {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                  } else {
                    if ($scope.language === 'en' || $scope.language === 'EN') {
                      prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                    } else {
                      prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                    }
                  }
                } else {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                  }
                  prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                }
                $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
                prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
                $scope.getAutoRefillSubscriptionInfo(
                  prepaidUserInfoService.getBAN(),
                  prepaidUserInfoService.getCTN(),
                  $scope.language
                );
              }
            },
            function(reason) {
              $scope.planAndAddOnInfoError = true;
            }
          );
        };

        $scope.getAutoRefillSubscriptionInfo = function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/refill/autorefill/scheduled/details', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.error != '') {
                $scope.autoRefillSubscriptionInfoError = true;
                console.log('AutoRefillSubscriptionInfo Error');
              } else {
                console.log('Got AutoRefillSubscriptionInfo Successfully');
                $scope.autoRefillSubscriptionInfo = result.data;
                console.log('$scope.autoRefillSubscriptionInfo :: ' + $scope.autoRefillSubscriptionInfo);
                prepaidAutoRefillInfoService.setAutoPayPlanInfo($scope.autoRefillSubscriptionInfo.autoPayPlan);
                prepaidAutoRefillInfoService.setAutoRefillBalanceInfo(
                  $scope.autoRefillSubscriptionInfo.autoRefillBalance
                );
                var $translate = $filter('translate');
                var $currency = $filter('currency');
                if (prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag) {
                  var $date = $filter('date');
                  var scheduledRefillDate = new Date($scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate);
                  $scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = scheduledRefillDate;
                  prepaidAutoRefillInfoService.setAutoPayPlanSubContent(
                    '<p class="fido-tick-icon">' +
                      $translate('global.label.nextPaymentOf') +
                      ' ' +
                      $currency(prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeAmount) +
                      '</p><p>' +
                      $translate('global.label.autoPayPlanBridge') +
                      ' ' +
                      $date(scheduledRefillDate, 'MMMM dd, yyyy') +
                      '</p>'
                  );
                  prepaidAutoRefillInfoService.setAutoPayPlanContentClass(
                    'tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-2'
                  );
                  if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent(
                      '<p class="fido-tick-icon-secondary">' +
                        $translate('global.label.add') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) +
                        ' ' +
                        $translate('global.label.autoRefillBalanceBridge') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) +
                        '</p>'
                    );
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass(
                      'tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9'
                    );
                  } else {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                  }
                } else {
                  prepaidAutoRefillInfoService.setAutoPayPlanSubContent('');
                  prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5');
                  if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent(
                      '<p class="fido-tick-icon-secondary">' +
                        $translate('global.label.add') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) +
                        ' ' +
                        $translate('global.label.autoRefillBalanceBridge') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) +
                        '</p>'
                    );
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass(
                      'tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9'
                    );
                  } else {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                  }
                }
                $state.go('myAccount.prepaidRefill');
              }
            },
            function(reason) {
              $scope.autoRefillSubscriptionInfoError = true;
            }
          );
        };

        $scope.init();

        /**
         * Order Details Model Popup
         */
        $scope.orderDetailsPopup = function(orderId) {
          /* TODO: move the html and controller into the same folder, all dashboard goes into the same directory */
          uteModal.open({
            templateUrl: 'modules/my-account/overview/order-details-modal.html',
            controller: 'orderDetailModalCtrl',
            headerTitle: 'Order Details',
            orderId: orderId,
            size: 'lg'
          });
        };

        $scope.TEST = function() {
          $scope.returnModemModal = uteModal.open({
            templateUrl: 'views/templates/modal/self-serve-modem-modal.html',
            controller: 'selfServeModemCtrl',
            resolve: {
              action: 'return-modem'
            }
          });
        };

        $scope.TEST2 = function() {
          $scope.returnModemModal = uteModal.open({
            templateUrl: 'views/templates/modal/self-serve-modem-modal.html',
            controller: 'selfServeModemCtrl',
            resolve: {
              action: 'pickup-modem'
            }
          });
        };

        /*
         Get orders info and create slider
         */
        var internetAcct = _.filter($rootScope.userInfo.accounts, function(account) {
          return account.serviceName === 'Internet/TV';
        });

        if (internetAcct && (internetAcct || []).length > 0) {
          $scope.showOrderStatusInfo = 'LOADING';
          $http
            .post(uteEndpoint('v1/getOrderInfo'), {
              accountNumber: internetAcct[0].accountNumber
            })
            .success(function(data, status, headers, config) {
              var orderDetailReqData;
              if (data.orderInfo.error == '') {
                $scope.carousel = data.orderInfo.orders;
                changeTechInstallService.orderInfo = angular.copy(data.orderInfo);

                if (($scope.carousel || []).length > 0) {
                  $scope.showOrderStatusInfo = 'TRUE';
                } else {
                  $scope.showOrderStatusInfo = 'FALSE';
                }
              } else {
                $scope.showOrderStatusInfo = 'FALSE';
                changeTechInstallService.orderInfo = angular.copy(data.orderInfo);
              }
            })
            .error(function(data, status, headers, config) {
              $scope.showOrderStatusInfo = 'FALSE';
              changeTechInstallService.orderInfo = { error: '' };
            });
        }

        /**
         * Cancel With TV Model Popup
         */
        $scope.cancelWithTv = function() {
          uteModal.open({
            templateUrl: 'views/templates/modal/cancel-internet.html',
            controller: 'cancelServiceModalCtrl',
            headerTitle: 'internet title',
            ok: function() {
              console.log('OK');
            }
          });
        };

        /**
         * Order Terms Model Popup
         */
        $scope.orderTerms = function() {
          uteModal.open({
            templateUrl: 'views/templates/modal/order-terms-conditions.html',
            controller: 'cancelServiceModalCtrl',
            headerTitle: 'Order Terms &amp; Conditions'
          });
        };

        /**
         * Order Details Model Popup
         */
        $scope.orderDetails = function() {
          uteModal.open({
            templateUrl: 'views/templates/modal/order-details.html',
            controller: 'cancelServiceModalCtrl',
            headerTitle: 'Order Details'
          });
        };

        /**
         * Cancel Internet Model Popup
         */
        $scope.cancelInternet = function() {
          uteModal.open({
            templateUrl: 'views/templates/modal/cancel-internet-confirm.html',
            controller: 'cancelServiceModalCtrl',
            headerTitle: 'Cancel Internet'
          });
        };

        /**
         * Cancel TV Model Popup
         */
        $scope.cancelTV = function() {
          uteModal.open({
            templateUrl: 'views/templates/modal/cancel-internet-confirm.html',
            controller: 'cancelServiceModalCtrl',
            headerTitle: 'Cancel TV'
          });
        };

        $scope.chooseAccount = function(accountType, accountNumber, status) {
          $rootScope.accountChosen = true;
          $rootScope.accountStatus = status;
        };

        $scope.accountDelinquencyStatus = function(accountNumber) {
          var currentAccount = _.find($rootScope.userInfo.accounts, function(account) {
            return account.accountNumber === accountNumber;
          });
          if (currentAccount && currentAccount.delinquentStatus) {
            return currentAccount.delinquentStatus.toLowerCase();
          } else {
            return '';
          }
        };

        $scope.accountServiceName = function(accountNumber) {
          var currentAccount = _.find($rootScope.userInfo.accounts, function(account) {
            return account.accountNumber === accountNumber;
          });
          if (currentAccount && currentAccount.serviceName) {
            return currentAccount.serviceName.toLowerCase();
          } else {
            return '';
          }
        };

        $scope.viewBill = function(accountNumber) {
          console.log('viewBill accountNumber', accountNumber);

          $http
            .post(uteEndpoint('v2/retrieveBBToken'))
            .success(function(data, status, headers, config) {
              console.log('v2/retrieveBBToken. success ', data);
            })
            .error(function(data, status, headers, config) {
              console.log('v2/retrieveBBToken. error ', data);
            });
        };

        function getOrderDetail(dataObj) {
          $http
            .post(uteEndpoint('v1/getOrderDetail'), dataObj)
            .success(function(data, status, headers, config) {
              if (data.productInfo.error) {
                notifier.notify.error();
              } else {
              }
            })
            .error(function(data, status, headers, config) {});
        }

        $scope.addInternet = function() {
          //Triggering the brtperiod before navigating to internet page, as there was an issue while navigating from overview to internet page
          //Issue: Had to click on Add Internet button twice to navigate
          brt.getBRTPeriod().then(function() {
            $state.go('internet');
          });
        };

        // FUSS-160 Logic to display Limited Access Banner - START
        $scope.checkAccountOrSubscriberIsFlagged = function() {
          $scope.isAccountOrSubscriberFlagged = false;
          _.each($scope.accountDetails, function(accountDetail) {
            if (
              accountDetail.accountNumber == $scope.accountNumberSelected &&
              accountDetail.accountStatus &&
              accountDetail.accountStatus.toUpperCase() === 'CANCELLED'
            ) {
              $scope.isAccountOrSubscriberFlagged = true;
              return true;
            }
          });
          return $scope.isAccountOrSubscriberFlagged;
        };
        // FUSS-160 Logic to display Limited Access Banner - END

        //FUSS-732 Switch to online bill promo
        $scope.showOLBPreference = commonService.showOnlinePromo;
        $scope.isWcocBRT = permissionsService.permissionDetail.isWcocBRT;
        //BRT switch for online bill promo
        $scope.showOnlinePromo = commonService.showOnlinePromo;

        $scope.deepLinking();

        //logic was moved to onlineBillingService
        $scope.onlineBillingPromoPopUp = onlineBillingService.onlineBillingPopUp;

        //FUSS-3074- My Account changes
        $scope.accountDetailsObj = commonService.accountDetails;
        $scope.showUsage = function() {
          _.each($scope.accountDetailsObj, function(accountDetail) {
            if (accountDetail.accountNumber == $scope.accountNumberSelected) {
              var subscriberNo,
                state = '',
                stateName = '',
                accountNumber = accountDetail.accountNumber;
              if (accountDetail.hasWireless) {
                stateName = accountDetail.LOB && accountDetail.LOB === 'WLPP' ? 'prepaidWLDashboard' : 'wireless';
                subscriberNo = accountDetail.subscriberServices[0].wireless.subscriberNo;
              } else if (accountDetail.hasInternet) {
                stateName = 'internet';
                subscriberNo = accountDetail.subscriberServices[0].internet.subscriberNo;
              }
              state = 'myAccount.' + stateName;
              $state.go(state, { accountNumber: accountNumber, subscriberNo: subscriberNo });
            }
          });
        };
        $scope.keyPressShowUsage = function(event) {
          if (event.which === 13) {
            $scope.showUsage();
          }
        };
        $scope.keyPressSwitchNow = function(event) {
          if (event.which === 13) {
            $scope.onlineBillingPromoPopUp('SwitchNow');
          }
        };
        $scope.keyPressLearnMore = function(event) {
          if (event.which === 13) {
            $scope.onlineBillingPromoPopUp('LearnMore');
          }
        };

        $scope.showUsageLink = false;
        $scope.showLink = function() {
          _.each($scope.accountDetailsObj, function(accountDetail) {
            if (accountDetail.accountNumber === $scope.accountNumberSelected) {
              if (
                accountDetail.subscriberServices.length > 0 &&
                accountDetail.accountStatus &&
                accountDetail.accountStatus.toUpperCase() !== 'CANCELLED' &&
                accountDetail.accountStatus.toUpperCase() !== 'SUSPENDED'
              ) {
                $scope.showUsageLink = true;
              }
            }
          });
        };
        $scope.showLink();

        $timeout(function() {
          if ($stateParams.isPayInteracResponse) {
            console.log('interac response:' + $stateParams.isPayInteracResponse);
            $state.go('myAccount.payNowInteracEnhanceResponse', { response: $stateParams.isPayInteracResponse });
          }
        }, 1200);

        $scope.hideNotification = function() {
          $scope.showBillNotification = false;
          $window.localStorage.setItem('hideBillNotificationMessage', $rootScope.userInfo.userID);
        };

        $scope.displayPaymentDate = function(account) {
          return (
            account &&
            Number(account.balance) > 0 &&
            $scope.accountStatus(account.accountNumber) !== 'SUSPENDED' &&
            account.paymentDueDate && account.paymentDueDate !== 'null' &&
            account.MOPType === 'invoice'
          );
        };

        $scope.displayAddToCalendar = function(account) {
          return (
            !!$scope.addToCalendar &&
            account.methodOfPaymentDetails &&
            account.methodOfPaymentDetails.moptype.toLowerCase() === 'r' &&
            account.LOB !== 'WLPP' &&
            $scope.displayPaymentDate(account)
          );
        };

        $scope.formatCalendarDate = function(date, hours) {
          // Microsoft, Yahoo and Google accept this format: "20170810T170000Z"
          return (
            moment(date, 'YYYYMMDD')
              .add(hours, 'hours')
              .utc()
              .format('YYYYMMDDTHHmmss') + 'Z'
          );
        };
        $scope.heroOffers = function(ctn) {
          bpoIntegrationService.getHeroOffers(ctn);
        };
        $scope.isBpoEligible = function(ctn) {
          var bpoEligibleCTNs = [];
          var eligible = false;
          bpoEligibleCTNs = uteBlocksPersistentStorageService.getFromSession('bpoCTNList');
          _.each(bpoEligibleCTNs, function(bpoEligibleCTN) {
            if (bpoEligibleCTN == ctn) {
              eligible = true;
            }
          });
          return eligible;
        };

        $scope.checkAALEligibility = function(account) {
          commonService.checkAALEligibility(account);
        };
        $scope.$on('$viewContentLoaded', function(event) {
          try {
            if (dynatracePageLoadActionId) {
              dtrum.leaveAction(dynatracePageLoadActionId);
              dynatracePageLoadActionId = null;
            }
          } catch (error) {}
        });
      }
    ]);
})();
